import { Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Permission } from "@interfaces/user";
import { AuthService, ChatService, HeaderService, LearnService } from "@app/services";
import { PermissionsService } from '@app/services/permissions.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"]
})
export class DashboardComponent implements OnInit {
  userSummary: any;
  hasJobBookingPermission = false;
  hasContentViewingPermission = false;
  hasJobCheckingInPermission = false;
  hasJobSigningOffPermission = false;
  hasInvoicePermission = false;
  hasClientAdministratorPermission = false;
  hasJobConfirmationPermission = false;
  hasTalentPoolUsePermission = false;
  joinCommunityLink = "";
  userToken: string;

  constructor(
    private headerService: HeaderService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private auth: AuthService,
    private chatService: ChatService,
    private learnService: LearnService,
    destroyRef: DestroyRef,
    permissionsService: PermissionsService,
  ) {
    this.auth.tokenChanges$.pipe(takeUntilDestroyed(destroyRef)).subscribe(token => {
      this.userToken = token;
      this.joinCommunityLink = this.learnService.getLearnUrl(token || '');
    });
    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(destroyRef)).subscribe((params: Params) => {
      var chatTo = params['chatTo'];
      var chatRoom = this.chatService.tryGetChatRoomByContactUserId(chatTo);

      if (chatRoom !== undefined) {
        this.chatService.selectChatRoom(chatRoom);
      }
    });

    combineLatest([this.activatedRoute.data, permissionsService.permissions$])
      .pipe(takeUntilDestroyed(destroyRef)).subscribe(([data, permissions]) => {
      this.userSummary = data.user;

      if (this.userSummary) {
        this.hasJobBookingPermission =
          permissions.indexOf(Permission.JobBooking) !== -1;
        this.hasContentViewingPermission =
          permissions.indexOf(Permission.ContentViewing) !== -1;
        this.hasJobCheckingInPermission =
          permissions.indexOf(Permission.JobCheckingIn) !== -1;
        this.hasJobSigningOffPermission =
          permissions.indexOf(Permission.JobSigningOff) !== -1;
        this.hasTalentPoolUsePermission =
          permissions.indexOf(Permission.Talent) !== -1;
        this.hasInvoicePermission = 
          permissions.indexOf(Permission.Invoice) !== -1;
        this.hasClientAdministratorPermission =
          permissions.indexOf(Permission.ClientAdministrator) !== -1;
        this.hasJobConfirmationPermission =
          permissions.indexOf(Permission.JobConfirmation) !== -1;
      }

      if (this.hasJobBookingPermission) {
        this.router.navigate(["/add-job"]);
        return;
      }
      if (this.hasJobSigningOffPermission) {
        this.router.navigate(["/manage-jobs/completedjobs"]);
        return;
      }
      if (this.hasContentViewingPermission) {
        if (!this.hasClientAdministratorPermission && !this.hasJobConfirmationPermission && !this.hasInvoicePermission) {
          this.learnService.gotoLearn();
        } else {
          this.router.navigate(["/hub"]);
        }
        return;
      }
    });
  }

  ngOnInit() { }
}
